import React from 'react';
import OfferCarouselContainer from 'partial/OfferManager/OfferCarouselContainer';

const DefaultView = props => {
  const { isDefaultModuleViewDisabled } = props;
  const pagePosition =
    props.extraAttributes && props.extraAttributes.pagePosition
      ? props.extraAttributes.pagePosition
      : null;
  const modulePosition =
    props.extraAttributes && props.extraAttributes.modulePosition
      ? props.extraAttributes.modulePosition
      : props.modulePosition;
  if (isDefaultModuleViewDisabled) {
    return <></>;
  } else {
    return (
      <div>
        {props.showHeader && <h1>{props.module}</h1>}
        <div>
          <OfferCarouselContainer
            offers={props.offers}
            eventHandler={props.eventHandler}
            containerType={props.module}
            extraAttributes={props.extraAttributes}
            isOcfPage={props.isOcfPage}
            partnersCustomTrackingMeta={props.partnersCustomTrackingMeta}
            pagePosition={pagePosition}
            modulePosition={modulePosition}
          />
        </div>
      </div>
    );
  }
};

export default DefaultView;
